<template>
  <div>
    <h3>You logged <span>{{thirtytime}}</span> in the last <router-link to="/reports/seven" class="reports-btn">7 days</router-link> <router-link to="/reports/fourteen" class="reports-btn">14 days</router-link> <router-link to="/reports/thirty" class="reports-btn">30 days</router-link></h3>
    <reports-charts :chart-data="datasetsfull" :height="300" :options="{responsive: true, maintainAspectRatio: false}"></reports-charts>
  </div>
</template>

<script>
  import ReportsCharts from '@/components/ReportsCharts'
  import axios from 'axios'
  import moment from 'moment'
  import tz from 'moment-timezone'
  import { store } from '../../store/store'
  import _ from 'underscore'
  export default {
    name: 'Thirty',
    components: { ReportsCharts },
    data () {
      return {
        thirtytime: ''
      }
    },
    beforeRouteEnter (to, from, next) {
      function getThirty () {
        var _thirtydays = 30; // Days you want to subtract
        var _date = new Date();
        var _last = new Date(_date.getTime() - (_thirtydays * 24 * 60 * 60 * 1000));
        var _day =_last.getDate();
        _day = ( _day < 10 ? "0" : "" ) + _day;
        var _month= _last.getMonth()+1;
        _month = ( _month < 10 ? "0" : "" ) + _month;
        var _year= _last.getFullYear();

        var _thadate = _year + '-' + _month + '-' + _day
        return _thadate + " 00:00:00"
      }
      let thirtydays = getThirty()
      let today = moment().format("Y-MM-D") + " 23:59:59";
      function secondsToHumanize (time) {
        time = moment.duration(time, "seconds").humanize();
        return time
      }
      axios.get('https://api.kuzcoapp.com/api/v1/report?start=' + thirtydays + '&end=' + today )
        .then( function (response) {
          let _totaltime = response.data.data.total_time
          let _reports = response.data.data.reports
          let momentThirty = () => {
            let arr= []
            let _today = {
              date: moment().format('YYYY-MM-DD'),
              time: "0"
            }
            arr.push(_today)
            for(let i = 1; i < 30; i += 1) {
              let ym = moment().subtract(i, 'days').format('YYYY-MM-DD');
              let rm = moment(ym).format('MMMM Do')
              let dm = {
                date: ym,
                time: "0"
              }
              arr.push(dm)
            }
            return arr
          }
          let _thirty = momentThirty()

          function mergeByProperty(_thirty, _reports, prop) {
            _.each(_reports, function(arr2obj) {
              var arr1obj = _.find(_thirty, function(arr1obj) {
                return arr1obj[prop] === arr2obj[prop];
              });

              //If the object already exist extend it with the new values from arr2, otherwise just add the new object to arr1
              arr1obj ? _.extend(arr1obj, arr2obj) : _thirty.push(arr2obj);
            });
          }
          mergeByProperty(_thirty, _reports, 'date');
          //extracts the time and date from the api response
          let timeresult = _thirty.map(function(a) {
            a.time = a.time + "000"
            a.time = Number(a.time)
            a.time = Math.round(moment.duration(a.time).asMinutes())
            return a.time;
          });
          let dateresult = _thirty.map(function(a) {
            a.date = moment(a.date).format('MMMM Do')
            return a.date;
          });
          next(vm => {
            vm.cdays = dateresult.reverse()
            vm.ctimes = timeresult.reverse()
            store.commit('_charttimes', timeresult)
            store.commit('_chartdays', dateresult)
            vm.thirtytime = secondsToHumanize(_totaltime)
          })

        })
        .catch ( function(error) {
          next(false)
        });
    },
    watch: {
      $route () {
        function getThirty () {
          var _thirtydays = 30; // Days you want to subtract
          var _date = new Date();
          var _last = new Date(_date.getTime() - (_thirtydays * 24 * 60 * 60 * 1000));
          var _day =_last.getDate();
          _day = ( _day < 10 ? "0" : "" ) + _day;
          var _month= _last.getMonth()+1;
          _month = ( _month < 10 ? "0" : "" ) + _month;
          var _year= _last.getFullYear();

          var _thadate = _year + '-' + _month + '-' + _day
          return _thadate + " 00:00:00"
        }
        let thirtydays = getThirty()
        let today = moment().format("Y-MM-D") + " 23:59:59";
        let self = this;
        function secondsToHumanize (time) {
          time = moment.duration(time, "seconds").humanize();
          return time
        }
        axios.get('https://api.kuzcoapp.com/api/v1/report?start=' + thirtydays + '&end=' + today )
          .then( function (response) {
            let _totaltime = response.data.data.total_time
            let _reports = response.data.data.reports
            let momentThirty = () => {
              let arr= []
              let _today = {
                date: moment().format('YYYY-MM-DD'),
                time: "0"
              }
              arr.push(_today)
              for(let i = 1; i < 30; i += 1) {
                let ym = moment().subtract(i, 'days').format('YYYY-MM-DD');
                let rm = moment(ym).format('MMMM Do')
                let dm = {
                  date: ym,
                  time: "0"
                }
                arr.push(dm)
              }
              return arr
            }
            let _thirty = momentThirty()

            function mergeByProperty(_thirty, _reports, prop) {
              _.each(_reports, function(arr2obj) {
                var arr1obj = _.find(_thirty, function(arr1obj) {
                  return arr1obj[prop] === arr2obj[prop];
                });
                //If the object already exist extend it with the new values from arr2, otherwise just add the new object to arr1
                arr1obj ? _.extend(arr1obj, arr2obj) : _thirty.push(arr2obj);
              });
            }
            mergeByProperty(_thirty, _reports, 'date');
            //extracts the time and date from the api response
            let timeresult = _thirty.map(function(a) {
              a.time = a.time + "000"
              a.time = Number(a.time)
              a.time = Math.round(moment.duration(a.time).asMinutes())
              return a.time;
            });
            let dateresult = _thirty.map(function(a) {
              a.date = moment(a.date).format('MMMM Do')
              return a.date;
            });

            self.cdays = dateresult.reverse()
            self.ctimes = timeresult.reverse()
            store.commit('_charttimes', timeresult)
            store.commit('_chartdays', dateresult)

            self.thirtytime = secondsToHumanize(_totaltime)

          })
          .catch ( function(error) {
          });
      }
    },
    computed: {
      chartdays () {
        return store.state.chartdays
      },
      charttimes () {
        return store.state.charttimes
      },
      datasetsfull () {
        return {
          labels: store.state.chartdays,
          datasets: [
            {
              label: 'Time(Hours)',
              backgroundColor: '#40cf97',
              data: store.state.charttimes
            }
          ]
        }
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  h3 {
    font-size: 20px;
    margin-bottom: 20px;
    span {
      font-family: "Proxima Bold";
    }
  }
  .reports-btn {
    border-color: $kuzcogreen;
    color: $kuzcogreen;
    border-radius: 3px;
    border: 1px solid;
    font-size: 13px;
    padding: 2px 5px;
  }
  .router-link-active {
    outline: 0;
    -webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
    color: #333;
    background-color: #e6e6e6;
    border-color: #adadad;
  }
</style>



// WEBPACK FOOTER //
// Thirty.vue?1088daca